"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import {env} from "next-runtime-env";

export default function LoginPage() {
  const router = useRouter();

  useEffect(() => {
    router.replace(env('NEXT_PUBLIC_SITE_LOGIN_URL')!);
  }, [router]);

  return <p>Redirecting...</p>;
}
